import React from 'react';
import Icon from '../../../components/AppIcon';

const MarketSentimentCard = ({ insights }) => {
  const getSentimentStatus = () => {
    const avgChange = parseFloat(insights?.avgChange || 0);
    if (avgChange > 10) return { label: 'Very Bullish', color: 'text-success', icon: 'TrendingUp', bg: 'bg-success/10' };
    if (avgChange > 0) return { label: 'Bullish', color: 'text-success', icon: 'ArrowUp', bg: 'bg-success/10' };
    if (avgChange > -10) return { label: 'Bearish', color: 'text-error', icon: 'ArrowDown', bg: 'bg-error/10' };
    return { label: 'Very Bearish', color: 'text-error', icon: 'TrendingDown', bg: 'bg-error/10' };
  };

  const sentiment = getSentimentStatus();

  return (
    <div className="bg-card rounded-lg border border-border p-6 h-full">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-accent/10 flex items-center justify-center">
          <Icon name="Activity" size={20} className="text-accent" />
        </div>
        <div>
          <h3 className="text-xl font-bold text-foreground">Market Sentiment</h3>
          <p className="text-sm text-muted-foreground">Overall market indicators</p>
        </div>
      </div>

      {/* Sentiment Status */}
      <div className={`${sentiment?.bg} rounded-lg p-4 mb-6`}>
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm text-muted-foreground">Current Sentiment</span>
          <Icon name={sentiment?.icon} size={20} className={sentiment?.color} />
        </div>
        <p className={`text-2xl font-bold ${sentiment?.color}`}>{sentiment?.label}</p>
      </div>

      {/* Market Breakdown */}
      <div className="space-y-4">
        <div>
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-muted-foreground">Value Increasing</span>
            <span className="text-sm font-semibold text-success">{insights?.increasing || 0}</span>
          </div>
          <div className="w-full bg-muted rounded-full h-2">
            <div 
              className="bg-success rounded-full h-2 transition-all duration-300"
              style={{ width: `${insights?.totalPlayers > 0 ? (insights?.increasing / insights?.totalPlayers * 100) : 0}%` }}
            />
          </div>
        </div>

        <div>
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-muted-foreground">Value Stable</span>
            <span className="text-sm font-semibold text-foreground">{insights?.stable || 0}</span>
          </div>
          <div className="w-full bg-muted rounded-full h-2">
            <div 
              className="bg-warning rounded-full h-2 transition-all duration-300"
              style={{ width: `${insights?.totalPlayers > 0 ? (insights?.stable / insights?.totalPlayers * 100) : 0}%` }}
            />
          </div>
        </div>

        <div>
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-muted-foreground">Value Decreasing</span>
            <span className="text-sm font-semibold text-error">{insights?.decreasing || 0}</span>
          </div>
          <div className="w-full bg-muted rounded-full h-2">
            <div 
              className="bg-error rounded-full h-2 transition-all duration-300"
              style={{ width: `${insights?.totalPlayers > 0 ? (insights?.decreasing / insights?.totalPlayers * 100) : 0}%` }}
            />
          </div>
        </div>
      </div>

      {/* Market Intelligence */}
      <div className="mt-6 pt-6 border-t border-border">
        <h4 className="text-sm font-semibold text-foreground mb-3">Market Intelligence</h4>
        <div className="space-y-2">
          <div className="flex items-start gap-2">
            <Icon name="Info" size={16} className="text-primary mt-0.5" />
            <p className="text-xs text-muted-foreground">
              {insights?.increasing > insights?.decreasing 
                ? 'Market showing positive momentum with more players gaining value' :'Market experiencing correction with value adjustments across players'
              }
            </p>
          </div>
          <div className="flex items-start gap-2">
            <Icon name="TrendingUp" size={16} className="text-accent mt-0.5" />
            <p className="text-xs text-muted-foreground">
              Average market change: {insights?.avgChange}% across tracked players
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketSentimentCard;